import { createApiConfig } from "./config";

import { ACCOUNTS_API_URL, RESTAURANT_ADMIN_API_URL, USER_API_URL } from "./routes"

const apiConfig = createApiConfig();

// GET restaurant admin

export const getUserList = (id) => apiConfig.get(`${ACCOUNTS_API_URL}/${id}/users`);

// CREATE restaurant admin

export const addUserList = (data) => apiConfig.post(USER_API_URL, data);

// DELETE restaurant admin

export const deleteUserList = (id) => apiConfig.delete(`${USER_API_URL}/${id}`);


// Update restaurant admin

export const updateUserList = (id,data) => apiConfig.put(`${USER_API_URL}/${id}`, data);

